var _require = require('./overlay.shell'),
  buildRustscriptOverlay = _require.buildRustscriptOverlay;
var _require2 = require('./import-dropzone'),
  dropzoneMarkup = _require2.dropzoneMarkup;
module.exports = {
  idleOverlay: function idleOverlay() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$error = _ref.error,
      error = _ref$error === void 0 ? '' : _ref$error;
    var errorBlock = error ? "<p class=\"rs-import-error\" role=\"alert\">".concat(error, "</p>") : "<p class=\"rs-import-error\" hidden role=\"alert\"></p>";
    return buildRustscriptOverlay({
      className: 'rs-overlay-modal rs-import-overlay',
      title: 'Import Transaction',
      titleClass: 'rs-overlay-title-hero',
      bodyHtml: "\n        ".concat(dropzoneMarkup({
        id: 'rs-import-drop-zone',
        ariaLabel: 'Import transaction file',
        lead: 'drag and drop a transaction file here',
        clickHint: 'or click here'
      }), "\n\n        ").concat(errorBlock, "\n\n        <div class=\"rs-import-divider\" aria-hidden=\"true\"><span>OR</span></div>\n\n        <section class=\"rs-import-p2sh\">\n          <h3 class=\"rs-import-p2sh-heading\">Import from P2SH Link</h3>\n          <div class=\"rs-import-p2sh-row\">\n            <input type=\"text\" class=\"saito-input rs-import-p2sh-input\" placeholder=\"Paste P2SH link\u2026\" spellcheck=\"false\" autocomplete=\"off\" />\n            <button type=\"button\" class=\"rs-btn rs-btn-secondary rs-import-p2sh-btn\" data-action=\"import-p2sh-link\">Import</button>\n          </div>\n        </section>\n      ")
    });
  },
  loadingOverlay: function loadingOverlay() {
    return buildRustscriptOverlay({
      className: 'rs-overlay-modal rs-overlay-status rs-import-overlay rs-import-loading',
      title: 'Loading transaction…',
      titleClass: 'rs-overlay-title-loading',
      bodyHtml: "\n        <div class=\"rs-publish-spinner\" aria-hidden=\"true\">\n          <span class=\"rs-publish-spinner-box\"></span>\n          <span class=\"rs-publish-spinner-box\"></span>\n          <span class=\"rs-publish-spinner-box\"></span>\n          <span class=\"rs-publish-spinner-box\"></span>\n        </div>\n        <p class=\"rs-overlay-lead rs-import-loading-lead\">Processing your transaction file.</p>\n      "
    });
  }
};